.g0{border:1px solid #ddd;}